(function() {
    'use strict';
a3_cabin_reports.factory('SaCrewAssessmentFactory', SaCrewAssessmentFactory);
                                                   
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SaCrewAssessmentFactory
    * @description 
    *   Add, Update, Delete and Get Cabin Crew Feedback.
    * @ngInject
    */
function SaCrewAssessmentFactory(localStorageMD5Service, SaCrewAssessmentMemberFactory, FlightFactory, 
				GenericService, CrewRouteFactory, SaFeedbackInfoFactory, UserFactory, defaultCalendarDate) {

        /**
        * Initialize the CrewAssessment
        * @memberof SaCrewAssessmentFactory
        */
		function SaCrewAssessment() {
			this.Id = null;
			this.AuthorId = null;
			this.Route = null;
			this.DutyDate = null;
			this.DutyDay = null;
			this.DutyNo = null;
			this.AcType = null;
			this.Status = 'Pending';
			this.IsExist = false;
			this.assessedBy = [];
			this.CrewAssessmentMembers = [];
			this.Flights = [];
			this.GetId = GetId;
            this.start = null;
            this.end = null;
			this.FeedbackDate = null;
		}
				
		var objType = 'SaCrewAssessments';
		var objCallback = SaCrewAssessment;  
				
		var service = 
		{  
			getCrewAssessmentsFromStorage : getCrewAssessmentsFromStorage,
			setCrewAssessmentsToStorage : setCrewAssessmentsToStorage,
			setCrewAssessmentToStorage : setCrewAssessmentToStorage,
			getCrewAssessmentFromStorage : getCrewAssessmentFromStorage,
			getCountOfUncompletedAssessments : getCountOfUncompletedAssessments,
			getCrewAssessmentByDutyNoAndDay : getCrewAssessmentByDutyNoAndDay,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			getNewCrewAssessment : getNewCrewAssessment,
			getTempAssessment : getTempAssessment,
			saveTempAssessment : saveTempAssessment,
			clearTempAssessment : clearTempAssessment,
			updateCrewAssessment : updateCrewAssessment,
			existsForRouteDutyDate : existsForRouteDutyDate,
			getAssementsReadyToSend : getAssementsReadyToSend,
			storeFlightsWithAssessments : storeFlightsWithAssessments,
			updateFlightsAssessment : updateFlightsAssessment,
            updateAssessmentFlights : updateAssessmentFlights,
			updateAndMergeAllSaAssessments: updateAndMergeAllSaAssessments
		};
		
		//object functions
        /**
         * Overide default get Id
         * @memberof SaCrewAssessmentFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

		//factory functions
         /**
         * Get Crew Assessments
         * @memberof SaCrewAssessmentFactory
         * @returns {Array} crewAssesments 
         */
		function getCrewAssessmentsFromStorage() {
            var lsItems = GenericService.list(objType,objCallback);
            var items = [];
            for (var i = 0; i < lsItems.length; i++) {
				if (lsItems[i]) {
					items.push(lsItems[i]);
				}
			}
			return items;
		}

        /**
         * Save Crew Assessments to storage
         * @memberof SaCrewAssessmentFactory
         * @param {Array} crewAssessments A list of Cabin Crew Feedbacks
         */
		function setCrewAssessmentsToStorage(crewAssessments) {
			GenericService.saveAll(crewAssessments,objType,objCallback);
		}

        /**
         * Save one Crew Assessment to storage
         * @memberof SaCrewAssessmentFactory
         * @param {Object} crewAssessment A Cabin Crew Feedback
         */
		function setCrewAssessmentToStorage(crewAssessment) {
			GenericService.save(crewAssessment,objType,objCallback);
		}

        /**
         * Get a Crew Assessment from storage
         * @memberof SaCrewAssessmentFactory
         * @param {number} crewAssessmentId  the Id of the selected Crew Assessment
         * @returns {Object} crewAssesment
         */
		function getCrewAssessmentFromStorage(crewAssessmentId) {
			return GenericService.get(crewAssessmentId,objType,objCallback);
		}

        /**
         * Get Count of Uncompleted Assessments 
         * @memberof SaCrewAssessmentFactory
         * @returns {number} count
         */
		function getCountOfUncompletedAssessments() {
			var crewAssessments = getCrewAssessmentsFromStorage();
			var count = 0;
			if (crewAssessments == null)
				return 0;

			for (var i = 0; i < crewAssessments.length; i++) {
				if (!crewAssessments[i].IsExist && crewAssessments[i].Status != "Completed") {
					count++;
				}
			}
			return count;
		};

        /**
         * Get  Crew Assessment By route and Duty Date
         * @memberof SaCrewAssessmentFactory
         * @param {string} DutyNo  the Route of the desired Crew Assessment
         * @param {string} DutyDay  the Duty Date of the desired Crew Assessment
         * @returns {Object} crewAssesment
         */
		function getCrewAssessmentByDutyNoAndDay(dutyNo, dutyDay, feedbackDate) {
			var crewAssessments = getCrewAssessmentsFromStorage();
			if (crewAssessments == null)
				return null;

			var result = null;

			var arrayLength = crewAssessments.length;
			for (var i = 0; i < arrayLength; i++) {
				if (crewAssessments[i].DutyNo == dutyNo && crewAssessments[i].DutyDay == dutyDay && 
					(!crewAssessments[i].FeedbackDate || crewAssessments[i].FeedbackDate == feedbackDate )) {
					result = crewAssessments[i];
					break;
				}
			}
			return result;
		}

        /**
         * Extend Object from the default CrewAssessment Object
         * @memberof SaCrewAssessmentFactory
         * @param {Object} obj  a crewAssesment
         * @returns {Object} crewAssesment
         */
		function fromObject (obj){
			return GenericService.fromObject(obj,objCallback);
		}

        /**
         * Extend an array of Objects from the default CrewAssessment Object
         * @memberof SaCrewAssessmentFactory
         * @param {Array} objList  an Array Of crewAssesments
         * @returns {Array} crewAssesments
         */
		function fromObjectList (objList){
			return GenericService.fromObjectList(objList,objCallback);
		}

        /**
         * Initialize a new Crew Assessment from the default Constructor
         * @memberof SaCrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getNewCrewAssessment() {
			return GenericService.constructor(objCallback);
		};

    
        /**
         * Get the Temporary Assessment from the local storage
         * @memberof SaCrewAssessmentFactory
         * @returns {Object} crewAssesment
         */
		function getTempAssessment() {
			var crewAssessmentLocalEdit = localStorageMD5Service.get('SaCrewAssessmentLocalEdit_TEMP');
			return fromObject(crewAssessmentLocalEdit);
		};

        /**
         * Save the Temporary Assessment to  the local storage
         * @memberof SaCrewAssessmentFactory
         * @param {Object} assessment  a crewAssesment
         * @param {number} FlightId  a crewAssesment
         */
		function saveTempAssessment(assessment,FlightId) {
            if (assessment){
                assessment.FlightId = FlightId;
                localStorageMD5Service.remove('SaCrewAssessmentLocalEdit_TEMP');
                localStorageMD5Service.set('SaCrewAssessmentLocalEdit_TEMP', assessment);
            }
		};

        /**
         * Remove the Temporary Assessment of  the local storage
         * @memberof SaCrewAssessmentFactory
         */
		function clearTempAssessment() {
			localStorageMD5Service.remove('SaCrewAssessmentLocalEdit_TEMP');
		};
    
        /**
         * Update Assessment from the new Assessment from Sync
         * @memberof SaCrewAssessmentFactory
         * @param {Object} assessment  The assessment
         * @param {Object} newAssessment  The new assessment
         */		
		function updateCrewAssessment(assessment, newAssessment) {
			var crewAssessmentTemplate = SaFeedbackInfoFactory.getQuestions();
			if (crewAssessmentTemplate == null) return assessment;
		
			// Load the flight
			var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, newAssessment.FeedbackDate);
			if (flights == null) return assessment;
		
			assessment.Flights = [];
			assessment.AcType = flights[0].AcType;
			assessment.Base = flights[0].Departure;
			assessment = updateAssessmentFlights(assessment, flights);
			assessment.FeedbackDate = newAssessment.FeedbackDate;

			if(newAssessment.Id){
				assessment.Id = newAssessment.Id;
			}

			var isUpdated = false;
		
			// Flags to check member states
			var validCrewCount = 0;         // Non-outdated and exists
			var outdatedCrewCount = 0;      // Outdated
			var nonExistentCrewCount = 0;   // Non-outdated but doesn't exist
		
			//filter by feedback date
			newAssessment.CrewAssessmentMembers = crewAssessmentFilteredByFeedbackDate(newAssessment);
			//filter by common flights in the route
			var flightIds = flights.map(f => f.FlightId);
			newAssessment.CrewAssessmentMembers = filterCrewAssessmentMembersByCommonFlightsInRoute(newAssessment.CrewAssessmentMembers, flightIds);

			for (var i = 0; i < newAssessment.CrewAssessmentMembers.length; i++) {
				var isCreated = false;
		
				//Calculate the IsOutdated
				var IsOutdated = calculateIsOutdated(newAssessment.CrewAssessmentMembers[i].EndPeriod)
				// Update flags based on crew member status
				if (IsOutdated && !newAssessment.CrewAssessmentMembers[i].IsExist) {
					outdatedCrewCount++;
				} else if (!newAssessment.CrewAssessmentMembers[i].IsExist) {
					nonExistentCrewCount++;
				} else {
					validCrewCount++;
				}
				for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
					if (newAssessment.CrewAssessmentMembers[i].CrewAimsId == assessment.CrewAssessmentMembers[l].CrewAimsId ||
						newAssessment.CrewAssessmentMembers[i].CrewId == assessment.CrewAssessmentMembers[l].CrewId) {
		
						assessment.CrewAssessmentMembers[l].CrewAimsId = newAssessment.CrewAssessmentMembers[i].CrewAimsId;
						assessment.CrewAssessmentMembers[l].CrewId = newAssessment.CrewAssessmentMembers[i].CrewId;
						assessment.CrewAssessmentMembers[l].Name = newAssessment.CrewAssessmentMembers[i].Name;
						assessment.CrewAssessmentMembers[l].IsValid = true;
						assessment.CrewAssessmentMembers[l].IsOutdated = IsOutdated;
						assessment.CrewAssessmentMembers[l].EndPeriod = newAssessment.CrewAssessmentMembers[i].EndPeriod;

						var newAssessmentItems = [];
		
						for (var j = 0; j < crewAssessmentTemplate.length; j++) {
							var question = {
								Id: crewAssessmentTemplate[j].Id,
								Description: crewAssessmentTemplate[j].Description,
								Label: crewAssessmentTemplate[j].Label,
								OrderNo: crewAssessmentTemplate[j].OrderNo,
								ItemValue: crewAssessmentTemplate[j].ItemValue,
								ItemDescr: null
							}
							if (assessment.CrewAssessmentMembers[l].assessmentItems) {
								for (var h = 0; h < assessment.CrewAssessmentMembers[l].assessmentItems.length; h++) {
									if (crewAssessmentTemplate[j].Id == assessment.CrewAssessmentMembers[l].assessmentItems[h].Id) {
										question.ItemValue = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemValue;
										question.ItemDescr = assessment.CrewAssessmentMembers[l].assessmentItems[h].ItemDescr;
									}
								}
							}
							newAssessmentItems.push(question);
						}
						assessment.CrewAssessmentMembers[l].assessmentItems = newAssessmentItems;
		
						if (assessment.CrewAssessmentMembers[l].IsExist != newAssessment.CrewAssessmentMembers[i].IsExist) {
							assessment.CrewAssessmentMembers[l].IsExist = newAssessment.CrewAssessmentMembers[i].IsExist;
							isUpdated = true;
						}
						isCreated = true;
						break;
					}
				}
				if (!isCreated) {
					var crewMember = SaCrewAssessmentMemberFactory.newMember();
					crewMember.CrewAimsId = newAssessment.CrewAssessmentMembers[i].CrewAimsId;
					crewMember.CrewId = newAssessment.CrewAssessmentMembers[i].CrewId;
					crewMember.assessmentItems = crewAssessmentTemplate;
					crewMember.Name = newAssessment.CrewAssessmentMembers[i].Name;
					crewMember.IsCompleted = false;
					crewMember.IsValid = true;
					crewMember.IsExist = newAssessment.CrewAssessmentMembers[i].IsExist;
					crewMember.IsOutdated = newAssessment.CrewAssessmentMembers[i].IsOutdated;
					crewMember.EndPeriod = newAssessment.CrewAssessmentMembers[i].EndPeriod;
			
					assessment.CrewAssessmentMembers.push(crewMember);
					isUpdated = true;
				}
			}
		
			for (var l = 0; l < assessment.CrewAssessmentMembers.length; l++) {
				var isExists = false;
				for (var i = 0; i < newAssessment.CrewAssessmentMembers.length; i++) {
					if (newAssessment.CrewAssessmentMembers[i].CrewAimsId == assessment.CrewAssessmentMembers[l].CrewAimsId ||
						newAssessment.CrewAssessmentMembers[i].CrewId == assessment.CrewAssessmentMembers[l].CrewId) {
						isExists = true;
						break;
					}
				}
				if (!isExists && !assessment.CrewAssessmentMembers[l].IsManual) {
					assessment.CrewAssessmentMembers.splice(l, 1);
					l--; // Adjust index after removal
					isUpdated = true;
				}
			}

			// Update the Status based on the flags
			if (validCrewCount > 0) {
				// If there's at least one valid (non-outdated and existing) crew member
				assessment.Status = "Stored";
			} else if (outdatedCrewCount > 0 && nonExistentCrewCount === 0) {
				// All members are outdated
				assessment.Status = "Outdated";
			} else if (nonExistentCrewCount > 0) {
				// If there are non-outdated but non-existent members
				assessment.Status = "Pending";
			} else if (isUpdated && assessment.Status == "Stored") {
				// If there were updates and it was stored before, downgrade to Draft
				assessment.Status = "Draft";
			}
			//set the Latest End Period
			assessment.LatestEndPeriod = moment.max(assessment.CrewAssessmentMembers.map(member => moment(member.EndPeriod))).toDate();

			assessment.assessedBy = newAssessment.assessedBy;
		
			// Update IsExist based on the flag
			assessment.IsExist = validCrewCount > 0;
		
			return assessment;
		}
			
        /**
         * Find if an assessment exists for the selected Route and Duty Date
         * @memberof SaCrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {boolean} isExist 
         */
		function existsForRouteDutyDate(Route, DutyDate) {
			var assessments = getCrewAssessmentsFromStorage();

			var isExist = false;
			for (var j = 0; j < assessments.length; j++) {
				if (assessments[j].Route == Route && assessments[j].DutyDate == DutyDate) {
					isExist = true;
					break;
				}
			}
			return isExist;
		}

        /**
         * Update Assessment Information from flights
         * @memberof SaCrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment
         * @param {Array} flights  The flights of the Assessment
         */
        function updateAssessmentFlights(crewAssessment,flights){
			for (var i = 0; i < flights.length; i++) {
                if(crewAssessment.start && crewAssessment.end){
                    var flightStart = Date.parse(flights[i].ScheduledDeparture);
                    var flightEnd = Date.parse(flights[i].ScheduledArrival);
 
                    var assesmentStart = Date.parse(crewAssessment.start);
                    if (flightStart<assesmentStart){
                         crewAssessment.start = flights[i].ScheduledDeparture;
                    }
                    else{
                        var assesmentEnd = Date.parse(crewAssessment.end);
                        if (flightEnd>assesmentEnd){
                            crewAssessment.end = flights[i].ScheduledArrival;
                        }  
                    }
                }else{
                    crewAssessment.start = flights[i].ScheduledDeparture;
                    crewAssessment.end = flights[i].ScheduledArrival;
                }
                
				var flight = {
					FlightId: flights[i].FlightId,
					ScheduledDepartureDateUTC: flights[i].ScheduledDepartureDateUTC,
					FlightNo: flights[i].FlightNo,
					Departure: flights[i].Departure,
					Arrival: flights[i].Arrival,
					ScheduledDepartureTimeUTC: flights[i].ScheduledDepartureTimeUTC,
                    ScheduledDeparture: flights[i].ScheduledDeparture,
					ScheduledArrival: flights[i].ScheduledArrival,
					AcTailNo: flights[i].AcTailNo,
					DutyDate: flights[i].DutyDate
				}
				crewAssessment.Flights.push(flight);
			}
            
            return crewAssessment;
        }
    
        /**
         * Returns the a list of cabin Crew Feedbacks that are ready to send (the reports of the assessment are completed or synched)
         * @memberof SaCrewAssessmentFactory
         * @param {string} Route  The route of the assessment
         * @param {string} DutyDate  The duty date of the assessment
         * @returns {Array} assessmentsToSend  
         */
		function getAssementsReadyToSend() {
			var assessments = getCrewAssessmentsFromStorage();
			var assessmentsToSend = [];
			for (var i = 0; i < assessments.length; i++) {
				if (assessments[i].Status == "Completed") {

					assessmentsToSend.push(assessments[i]);
				}

			}
			return assessmentsToSend;
		}

        /**
         * Update Assessments which are stored inside the flights 
         * @memberof SaCrewAssessmentFactory
         * @param {Object} crewAssessment  The crew assessment\
         */
		function updateFlightsAssessment(assessment) {
			var flights = FlightFactory.getFlightsFromStorage();
			for (var i = 0; i < flights.length; i++) {

				//TODO:: if assessment.Id =0 ? then route + dutyDate + feedbackdate
				if (flights[i].saAssessment && assessment.Id == flights[i].saAssessment.Id ){
					flights[i].saAssessment.Status = assessment.Status;
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

		/**
		 * Update and merge all SA assessments
		 * @memberof SaCrewAssessmentFactory
		 */
		function updateAndMergeAllSaAssessments(newSaAssessments) {
			var oldSaAssessments = getCrewAssessmentsFromStorage() || [];
			newSaAssessments = newSaAssessments || [];
			var finalSaAssessments = [];
			var assessmentsToCreate = [];

			// group old by Route+DutyDate
			var oldGroups = {};
			oldSaAssessments.forEach(item => {
				var key = item.Route + "|" + item.DutyDate;
				if (!oldGroups[key]) oldGroups[key] = [];
				oldGroups[key].push(item);
			});

			// group new by Route+DutyDate
			var newGroups = {};
			newSaAssessments.forEach(item => {
				var key = item.Route + "|" + item.DutyDate;
				if (!newGroups[key]) newGroups[key] = [];
				newGroups[key].push(item);
			});

			// process each new group
			for (var key in newGroups) {
				var newGroup = newGroups[key];
				var oldGroup = oldGroups[key] || [];

				if (newGroup.length === oldGroup.length && newGroup.length > 0) {
					// counts equal → update one by one, matched by FeedbackDate
					newGroup.forEach(n => {
						// find matching old by FeedbackDate 
						var match = oldGroup.find(o =>
							o.FeedbackDate === n.FeedbackDate 
							//|| (!o.FeedbackDate && !n.FeedbackDate) //(null/undefined allowed to match empty)
						);

						if (match) {
							var updated = updateCrewAssessment(match, n);
							finalSaAssessments.push(updated);
						} else {
							// no match → treat as new
							assessmentsToCreate.push(n);
						}
					});
				} else {
					// counts differ → ignore olds, just create all news
					assessmentsToCreate = assessmentsToCreate.concat(newGroup);
				}
			}

			// create new assessments
			var created = createCrewAssessments(assessmentsToCreate);
			finalSaAssessments = finalSaAssessments.concat(created);

			// replace storage with only updated + created
			setCrewAssessmentsToStorage(finalSaAssessments);
			storeFlightsWithAssessments();
		}

		 /**
         * Create New Crew Assessments from the api assessments
         * @memberof SaCrewAssessmentFactory
         * @returns {Array} crewAssessments 
         */
		 function createCrewAssessments(assessments) {
			var crewAssessments = [];
			for (var i = 0; i < assessments.length; i++) {
				var crewAssessment = createNewCrewAssessment(assessments[i])
                if(crewAssessment){
                   crewAssessments.push(crewAssessment);
                }
				
			}
			return crewAssessments;
		}

		/**
         * Create New Crew Assessment from the api assessments
         * @memberof SaCrewAssessmentFactory
         * @returns {object} assessment 
         */
		function createNewCrewAssessment(assessment) {
			// load the user
			var user = UserFactory.getUser();
			if (user == null)
				return null;

			// load the crewAssessmentTemplate
			var crewAssessmentTemplates = SaFeedbackInfoFactory.getQuestions();
			if (crewAssessmentTemplates == null)
				return null;

			// load the flight
			var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
			if (flights == null || flights.length==0)
				return null;

			// create the new crewAssessment
			var crewAssessment = getNewCrewAssessment();
			crewAssessment.Id = (!assessment.Id) ? guid() : assessment.Id;
			crewAssessment.AuthorId = user.id;
			crewAssessment.Route = assessment.Route;
			crewAssessment.DutyDate = assessment.DutyDate;
			crewAssessment.DutyDay = assessment.DutyDay;
			crewAssessment.DutyNo = assessment.DutyNo;

            crewAssessment.AcType = flights[0].AcType;
			crewAssessment.Base = flights[0].Departure;
			crewAssessment = updateAssessmentFlights(crewAssessment,flights);
			crewAssessment.assessedBy = assessment.assessedBy;
			crewAssessment.FeedbackDate = assessment.FeedbackDate;
			var IsExist = true;

			var flightIds = flights.map(f => f.FlightId);

			//filter by feedback date
			assessment.CrewAssessmentMembers = crewAssessmentFilteredByFeedbackDate(assessment);
			//filter by common flights in the route
			var flightIds = flights.map(f => f.FlightId);
			// Filter the CrewAssessmentMembers to include only those with common flights in the route
            assessment.CrewAssessmentMembers = filterCrewAssessmentMembersByCommonFlightsInRoute(assessment.CrewAssessmentMembers, flightIds);
 

			for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
				//check for double crew members, same day for multiday duties
				if(crewAssessment.CrewAssessmentMembers 
					&& !crewAssessment.CrewAssessmentMembers.some(member => member.CrewAimsId === assessment.CrewAssessmentMembers[i].CrewAimsId) ) {
						var crewMember = SaCrewAssessmentMemberFactory.newMember();
						crewMember.CrewAimsId = assessment.CrewAssessmentMembers[i].CrewAimsId;
						crewMember.CrewId = assessment.CrewAssessmentMembers[i].CrewId;
						crewMember.assessmentItems = crewAssessmentTemplates;
						crewMember.Name = assessment.CrewAssessmentMembers[i].Name;
						crewMember.IsCompleted = false;
						crewMember.IsValid = true;
						crewMember.IsExist = assessment.CrewAssessmentMembers[i].IsExist;
						crewMember.EndPeriod = assessment.CrewAssessmentMembers[i].EndPeriod;
		
						if (!assessment.CrewAssessmentMembers[i].IsExist) {
							IsExist = false;
						}
		
						crewAssessment.CrewAssessmentMembers.push(crewMember);
				}
			}
			//set the Latest End Period
			crewAssessment.LatestEndPeriod = moment.max(crewAssessment.CrewAssessmentMembers.map(member => moment(member.EndPeriod))).toDate();

			crewAssessment.IsExist = IsExist;
			if(IsExist){
				crewAssessment.Status = "Stored";
			}
			// return the new crewAssessment
			return crewAssessment;
		}

		 /**
         * Store Assessment inside the flights
         * @memberof SaCrewAssessmentFactory
         */
		function storeFlightsWithAssessments() {
			var flights = FlightFactory.getFlightsFromStorage();
			var crewAssessments = getCrewAssessmentsFromStorage();
			for (var i = 0; i < flights.length; i++) {
				for (var j = 0; j < crewAssessments.length; j++) {
					if (flights[i].Route == crewAssessments[j].Route 
							&& ( (crewAssessments[j].FeedbackDate && flights[i].FlightDate == crewAssessments[j].FeedbackDate)
								|| (!crewAssessments[j].FeedbackDate && flights[i].DutyDate == crewAssessments[j].DutyDate))
						){
						flights[i].saAssessment = {
							Id: crewAssessments[j].Id,
							Status: crewAssessments[j].Status,
							IsExist: crewAssessments[j].IsExist,
							//IsAssessedBy: crewAssessments[j].assessedBy.length > 0,
							IsCrewLess: crewAssessments[j].CrewAssessmentMembers.length < 1,
							FeedbackDate: crewAssessments[j].FeedbackDate,
							LatestEndPeriod: crewAssessments[j].LatestEndPeriod
						}
						break;
					}
				}
			}
			FlightFactory.setFlightsToStorage(flights);
		}

		// Filters the assessmentCrew to include only those matching the FeedbackDate (if any)
		function crewAssessmentFilteredByFeedbackDate(assessment){
			var filteredCrew = [];
			if (assessment && assessment.CrewAssessmentMembers && assessment.CrewAssessmentMembers.length > 0){
				for (var i = 0; i < assessment.CrewAssessmentMembers.length; i++) {
					if (!assessment.FeedbackDate || assessment.FeedbackDate == assessment.CrewAssessmentMembers[i].FlightDate){
						filteredCrew.push(assessment.CrewAssessmentMembers[i]);
					}
				}
			}
			return filteredCrew;
		}

		// Filters the CrewAssessmentMembers to include only those with common flights in the route
		function filterCrewAssessmentMembersByCommonFlightsInRoute(members, flightIdsInRoute) {
			if (!members || members.length === 0 || !flightIdsInRoute || flightIdsInRoute.length === 0) {
				return [];
			}
			var commonFlightsWithSA = localStorageMD5Service.get('CommonFlightsWithSA') || [];
			const faAimsIds = commonFlightsWithSA
								.filter(entry =>
									entry.Flights.some(flight => flightIdsInRoute.includes(flight.FlightId))
								)
								.map(entry => entry.SaAimsId);
			return members.filter(member => faAimsIds.includes(member.CrewAimsId));
		}

		function calculateIsOutdated(memberEndDate){
			if (!memberEndDate) return false;

			const endDate = new Date(memberEndDate);
			const today = defaultCalendarDate ? new Date(defaultCalendarDate) : new Date();

			// Add 1 day to the member's end date
			const endDatePlusOne = new Date(endDate);
			endDatePlusOne.setDate(endDate.getDate() + 1);

			// Normalize times to midnight for date-only comparison
			endDatePlusOne.setHours(0, 0, 0, 0);
			today.setHours(0, 0, 0, 0);

			// If (endDate + 1 day) is before OR equal to today → outdated
			return endDatePlusOne <= today;
		}

	return service;
	}
    
})();